// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DO_NOT_WANT_TO_TELL = "Neprezrad\u00edm :-)";
export const HOME_SIGNUP_BAZAAR = "pravidlami baz\u00e1ra";
export const HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link = "Registr\u00e1ciou s\u00fahlas\u00edm so %(common_link)s, %(bazaar_link)s a %(privacy_link)s.";
export const HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link = "U\u017e m\u00e1\u0161 u n\u00e1s \u00fa\u010det? %(link)s.";
export const HOME_SIGNUP_LOGIN_HERE = "Prihl\u00e1s sa tu";
export const HOME_SIGNUP_PRIVACY = "Z\u00e1sadami ochrany osobn\u00fdch \u00fadajov";
export const HOME_SIGNUP_VOP = "V\u0161eobecn\u00fdmi podmienkami pou\u017e\u00edvania";
export const PREGNANCY_STATE = "\u010cak\u00e1\u0161 b\u00e1b\u00e4tko?";
export const PREGNANT = "\u00c1no!";
export const SETTINGS_I_LIVE_ABROAD = "\u017dijem v zahrani\u010d\u00ed...";
export const SIGN_UP_AND_HAVE_PROFIT_IT_TAKES_ONLY_ONE_MINUTE_AND_IS_FREE = "Zaregistruj sa a z\u00edskaj pr\u00edstup do baz\u00e1ra, blogov \u010di diskusi\u00ed. Netrv\u00e1 to ani min\u00fatu a je to <b>\u00faplne zadarmo</b> :-)";
export const SIGNUP_BUTTON = "OK, zaregistruj ma";
export const SIGNUP_DUE_DATE = "Term\u00edn";
export const SIGNUP_EMAIL = "Email:";
export const SIGNUP_LOCATION_COUNTRY = "Bydlisko - krajina";
export const SIGNUP_LOCATION_COUNTY = "Bydlisko - okres";
export const SIGNUP_LOCATION_PLACE = "Bydlisko - obec";
export const SIGNUP_PASSWORD = "Heslo:";
export const SIGNUP_USERNAME = "Prihlasovacie meno:";
export const WE_ARE_TRYING_TO_CONCEIVE = "Nie, ale sna\u017e\u00edme sa...";
export const WE_HAVE_CHILDREN = "Nie";
